import { useEffect } from "react";
import { buildTitle } from "@/lib/pageTitle";

export function useDocumentTitle(suffix: string | null | undefined) {
  useEffect(() => {
    document.title = buildTitle(suffix);
  }, [suffix]);
}
